import React from "react";
import { InputRadio } from "@ebscois/react-component-library";
import {
  StyledDialogContainer,
  StyledDialogHeading,
  StyledDialogMessage,
  StyledRadioGroupLabel,
  StyledInputGroup,
  StyledTypeButtonWrapper,
  StyledSaveButton,
  StyledCancelButton,
} from "./_.styled";

const FollowDialog = ({
  isOpen,
  onRequestClose,
  onSave,
  subscriptionOptions = [],
}) => {
  const defaultOption =
    subscriptionOptions.length > 0
      ? subscriptionOptions[0].subscriptionType
      : null;

  const [selectedValue, setSelectedValue] = React.useState(defaultOption);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
  };

  const handleSave = () => {
    if (onSave) {
      onSave(selectedValue);
    }
  };

  // reset selected value to first option when dialog is closed
  React.useEffect(() => {
    if (!isOpen && selectedValue) {
      setSelectedValue(defaultOption);
    }
  }, [defaultOption, isOpen, selectedValue]);

  return (
    <StyledDialogContainer
      data-testid="dialog-container"
      onRequestClose={onRequestClose}
      isOpen={isOpen}
      maxWidth="sm"
    >
      <StyledDialogHeading element="h2">Follow</StyledDialogHeading>
      <StyledDialogMessage element="p">
        Get alerts when there are significant updates to this content.
      </StyledDialogMessage>
      {subscriptionOptions?.length > 0 && (
        <>
          <StyledRadioGroupLabel
            data-testid="dialog-select-options"
            fontWeight="bold"
          >
            Select:
          </StyledRadioGroupLabel>
          <StyledInputGroup
            data-testid="radiobutton-group"
            onChange={handleChange}
            selectedValue={selectedValue}
          >
            {subscriptionOptions.map(({ text, subscriptionType }) => (
              <InputRadio
                key={subscriptionType}
                id={subscriptionType}
                label={text}
                name="selection"
                value={subscriptionType}
              />
            ))}
          </StyledInputGroup>
        </>
      )}
      <StyledTypeButtonWrapper>
        <StyledSaveButton
          data-testid="follow-dialog-follow-button"
          onClick={handleSave}
          size="md"
          data-auto="follow-modal__follow-button"
          disabled={!selectedValue}
        >
          Follow
        </StyledSaveButton>
        <StyledCancelButton onClick={onRequestClose} size="md" kind="text">
          Cancel
        </StyledCancelButton>
      </StyledTypeButtonWrapper>
    </StyledDialogContainer>
  );
};

FollowDialog.displayName = "FollowDialog";

export default FollowDialog;
